import {GeomRelation} from "./geom-relation";

class SegmentByTwoPoints extends GeomRelation {
    constructor (objectId) {
        super();
        this.objectId = objectId;
    }

    dipose () {
        super.dispose();
    }
}
export {SegmentByTwoPoints}